import { Box, Typography } from '@mui/material';

type Props = {
  name?: string;
};

export const TIMELINE_SUMMARY_WIDTH = 150;

export default function Summary({ name }: Props) {
  return (
    <Box
      width={`${TIMELINE_SUMMARY_WIDTH}px`}
      sx={{
        userSelect: 'none'
      }}
    >
      <Typography
        sx={{
          width: 'calc(100% - 10px)',
          color: 'white',
          marginRight: 1,
          justifyContent: 'left',
          fontSize: '12px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
        }}
      >
        {name || ''}
      </Typography>
    </Box>
  );
}
